"use strict";

let filesToUpload = [];
let filePreviews = [];
function resetUgcData() {
  filesToUpload = [];
  filePreviews = [];
}
const createFilePreview = file => {
  const reader = new FileReader();
  function previewHandler(e) {
    const previewData = e.target.result;
    filePreviews.push({
      name: file.name,
      data: e.target.result
    });
    const mediaType = previewData.includes('data:image') ? 'image' : 'video';
    window.Unicorn.call("modal-ugc", "add_file_preview", file.name, mediaType);
  }
  ;
  reader.addEventListener('load', previewHandler);
  reader.readAsDataURL(file);
};
function reRenderPreviews() {
  const previewItems = document.querySelectorAll('.file__preview_item');
  // need to re - set all the previews on each change
  previewItems.forEach((item, idx) => {
    const imgElements = item.getElementsByTagName('img');
    const videoSourceElements = item.getElementsByTagName('source');
    const previewName = item.dataset?.previewFileName;
    const srcElement = imgElements.length ? imgElements : videoSourceElements;
    const previewData = filePreviews.find(preview => preview.name == previewName);
    if (srcElement.length) {
      srcElement[0].src = previewData?.data;
    }
  });
}
function showFilePreview(id, name) {
  const previewElement = document.getElementById(id);
  const removeButton = previewElement.getElementsByTagName("button");
  if (removeButton) {
    removeButton[0].addEventListener('click', e => {
      window.Unicorn.call("modal-ugc", "remove_file_preview", id);
      filePreviews = filePreviews.filter(file => file.name != name);
      filesToUpload = filesToUpload.filter(file => file.name != name);
    });
  }
  // need to re - set all the previews on each change
  reRenderPreviews();
}
;
function handleFileChange() {
  const fileSelector = document.getElementById("input_file_41");
  const files = fileSelector.files;
  if (!files.length) return;
  const file = files[0];
  const allowFileSize = 150 * 1048576;
  const fileLimit = 5;
  const fileType = file.type.split('/');
  const allowedSubTypes = {
    video: ['mp4', 'avi', 'x-ms-wmv', 'mpeg', 'quicktime', '3gpp', 'x-matroska'],
    image: ['jpeg', 'gif', 'bmp', 'png', 'svg+xml']
  };

  // if file format is not allowed
  if (!allowedSubTypes[fileType[0]]?.includes(fileType[1])) {
    window.Unicorn.call("modal-ugc", "set_error", "files", "format", "true");
    return;
  }

  // if file size is too big
  if (file.size > allowFileSize) {
    window.Unicorn.call("modal-ugc", "set_error", "files", "size", "true");
    return;
  }
  let filesTotalSize = file.size;
  filesToUpload.forEach(f => filesTotalSize += f.size);
  if (filesTotalSize >= allowFileSize) {
    window.Unicorn.call("modal-ugc", "set_error", "files", "total_size", "true");
    return;
  }
  if (filesToUpload.length >= fileLimit) {
    window.Unicorn.call("modal-ugc", "set_error", "files", "limit", "true");
    return;
  }
  createFilePreview(file);
  filesToUpload.push(file);
}
let ugcSendXHR;
function submitUgcForm() {
  function secondsToDhms(seconds) {
    let totalSeconds = Number(seconds);
    const timeMap = {
      d: 0,
      h: 0,
      m: 0,
      s: 0
    };
    if (totalSeconds / 86400 > 1) {
      timeMap.d = Math.floor(totalSeconds / 86400);
      totalSeconds -= 86400 * timeMap.d;
    } else if (totalSeconds / 3600 > 1) {
      timeMap.h = Math.floor(totalSeconds / 3600);
      totalSeconds -= 3600 * timeMap.h;
    } else if (totalSeconds / 60 > 1) {
      timeMap.m = Math.floor(totalSeconds / 60);
      totalSeconds -= 60 * timeMap.m;
    } else if (totalSeconds) {
      timeMap.s = totalSeconds;
    }
    const dDisplay = timeMap.d > 0 ? `${timeMap.d}dan(a), ` : '';
    const hDisplay = timeMap.h > 0 ? `${timeMap.h}sat(i), ` : '';
    const mDisplay = timeMap.m > 0 ? `${timeMap.m}min, ` : '';
    const sDisplay = timeMap.s > 0 ? `${timeMap.s}sek` : '';
    return `${dDisplay}${hDisplay}${mDisplay}${sDisplay}`;
  }
  function fetchForm(url, formData, startTime) {
    ugcSendXHR = new XMLHttpRequest();
    return new Promise(function (success, failure) {
      ugcSendXHR.onreadystatechange = function () {
        if (ugcSendXHR.readyState != 4) {
          // done
          return;
        }
        success({
          data: ugcSendXHR.response.data,
          status: ugcSendXHR.status
        });
      };
      ugcSendXHR.addEventListener('error', () => {
        failure(new TypeError('Failed to fetch'));
      });
      ugcSendXHR.upload.addEventListener('progress', e => {
        if (e.lengthComputable) {
          const elapsedTime = new Date().getTime() - startTime;
          const chunksPerTime = e.loaded / elapsedTime;
          const estimatedTotalTime = e.total / chunksPerTime;
          const timeLeftInSeconds = Math.ceil((estimatedTotalTime - elapsedTime) / 1000);
          const progress = (e.loaded / e.total * 100).toFixed(2);
          const timeLeft = secondsToDhms(timeLeftInSeconds);
          const progressEl = document.querySelector('.modal__progress_text');
          const progressBarEl = document.querySelector('.modal__progress_loader');
          progressEl.lastElementChild.innerHTML = timeLeft;
          progressBarEl.classList.add('is-active');
          progressBarEl.style.width = `${progress}%`;
        }
      });
      ugcSendXHR.responseType = 'json';
      ugcSendXHR.open('post', url, true);
      ugcSendXHR.send(formData);
    });
  }
  const component = window.Unicorn.getComponent('modal-ugc');
  const componentData = component.data;
  const formData = new FormData();
  const startTime = new Date().getTime();
  const url = `${window.baseApiUrl}/dynamic-forms/ugc/logs`;
  formData.append('name', componentData.name);
  formData.append('phone', componentData.phone);
  formData.append('message', componentData.description);
  formData.append('email', componentData.email);
  filesToUpload.forEach((file, i) => formData.append(`files${i + 1}`, file));
  fetchForm(url, formData, startTime).then(response => {
    if (response.status == 200) {
      window.showSnackbar(response.data.attributes.message, 'success');
      window.Unicorn.call('modal-ugc', 'hide');
    }
  }).catch(_ => {
    window.showSnackbar('Slanje tvoje poruke nije uspjelo.', 'error');
  }).finally(() => {
    ugcSendXHR = null;
  });
}
function cancelUgcSubmit() {
  window.Unicorn.call('modal-ugc', 'abort');
  ugcSendXHR.abort();
}